import ApiService from "@/api/baseApi/api-service";
import { Config } from "../../config";
import { IGetFilters, IGetFiltersParams } from "./interfaces/IGetFilters";

const URLs = {
  getFilters: "/filters",
};
class ApiFilters extends ApiService {
  constructor(config: Config) {
    super({ ...config });
  }
  getFilters = (params: IGetFiltersParams): Promise<IGetFilters> =>
    this.get(URLs.getFilters, { params });
}
export default ApiFilters;
